// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"52eb9745","263":"d82b0ee7","509":"61e8af51","836":"eeae09b5","981":"95880289"}[chunkId] + ".chunk.js";
};